export default __webpack_public_path__ + "static/media/plurato.c69c9fe3.png";